import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from 'primeng/api';
import { NgClass, NgStyle } from '@angular/common';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
  selector: 'ct-extraction-dialog',
  imports: [SharedModule, NgClass, NgStyle, ConfirmDialogModule],
  templateUrl: './dialog.component.html',
})
export class DialogComponent {
  /** `null` drops the footer button altogether **/
  @Input() closeText: string | null = 'Abbrechen';
  @Input() acceptText = 'Bestätigen';
  @Input({ required: true }) title = '';
  @Output() closeDialog = new EventEmitter<void>();
  @Output() acceptDialog = new EventEmitter<void>();
}
